export default () => {
    if (window.e_consent_config_json) {
        return window.e_consent_config_json;
    }
    if (window.e_consent_config_json_url) {
        return window.e_consent_config_json;
    }
    if (window.cookie_level_configuration) {
        return window.cookie_level_configuration;
    }

    throw new Error('unable to load e_consent config');
}
